import { render, staticRenderFns } from "./editOrigin.vue?vue&type=template&id=7fc53113&scoped=true"
import script from "./editOrigin.vue?vue&type=script&lang=js"
export * from "./editOrigin.vue?vue&type=script&lang=js"
import style0 from "./editOrigin.vue?vue&type=style&index=0&id=7fc53113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc53113",
  null
  
)

export default component.exports